import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "col-4 column items-center q-px-xs" }
const _hoisted_2 = { class: "primary-underlined row justify-start" }
const _hoisted_3 = { class: "bg-primary title-underlined q-px-sm q-py-xs" }
const _hoisted_4 = { class: "bg-grey q-pa-sm" }
const _hoisted_5 = { class: "text-secondary" }
const _hoisted_6 = { class: "right text-secondary" }
const _hoisted_7 = { class: "text-secondary" }
const _hoisted_8 = { class: "right text-secondary" }
const _hoisted_9 = {
  key: 0,
  class: "text-positive q-mt-sm q-pa-xs flex flex-row no-wrap items-center"
}
const _hoisted_10 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  style: {"width":"24px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  fillRule: "evenodd",
  d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
  clipRule: "evenodd"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "q-pl-sm" }
const _hoisted_14 = {
  key: 1,
  class: "text-amber-8 q-mt-sm q-pa-xs flex flex-row no-wrap items-center"
}
const _hoisted_15 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  style: {"width":"24px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  fillRule: "evenodd",
  d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "q-pl-sm" }
const _hoisted_19 = {
  key: 2,
  class: "text-negative q-mt-sm q-pa-xs flex flex-row no-wrap items-center"
}
const _hoisted_20 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  style: {"width":"24px"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "q-pl-sm" }
const _hoisted_24 = { class: "bg-grey q-pa-sm q-mt-xs" }
const _hoisted_25 = { class: "row text-primary primary-underlined" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "col-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("( mmol )")
const _hoisted_30 = { class: "col-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("( mmol/l )")
const _hoisted_33 = { class: "row product-table" }
const _hoisted_34 = {
  class: "col-6 bg-white q-pa-sm",
  style: {"border-bottom":"1px solid lightgrey"}
}
const _hoisted_35 = {
  class: "col-3 bg-white q-pa-sm",
  style: {"border-bottom":"1px solid lightgrey"}
}
const _hoisted_36 = {
  class: "col-3 bg-white q-pa-sm",
  style: {"border-bottom":"1px solid lightgrey"}
}
const _hoisted_37 = { class: "q-pa-xs q-mt-md col" }
const _hoisted_38 = { class: "q-mb-sm textsubtitle2" }
const _hoisted_39 = { class: "q-mb-sm textsubtitle2" }
const _hoisted_40 = { class: "q-mb-sm textsubtitle2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Osmolarity.Result.Title")), 1)
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle([{"width":"100%"}, !_ctx.mobile ? 'max-height: 1000px; overflow-y: auto' : '']),
      class: "col q-py-xs"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("Osmolarity.Result.TotalVolume")), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.results.totalSolutionVolume) + " ml", 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("Osmolarity.Result.OsmolarityOfTheMixture")), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(isNaN(_ctx.results.totalSolutionOsmo) ? 0 : _ctx.results.totalSolutionOsmo) + " mosm/l", 1),
        (_ctx.results.totalSolutionOsmo < 500)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("Osmolarity.Result.Warning.below500")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.results.totalSolutionOsmo >= 500 && _ctx.results.totalSolutionOsmo < 800)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17)),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("Osmolarity.Result.Warning.between500And800")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.results.totalSolutionOsmo >= 800)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22)),
              _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("Osmolarity.Result.Warning.above800")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("Osmolarity.Result.Ingredients")), 1),
          _createElementVNode("div", _hoisted_27, [
            _createTextVNode(_toDisplayString(_ctx.$t("Osmolarity.Result.Absolutely")), 1),
            _hoisted_28,
            _hoisted_29
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createTextVNode(_toDisplayString(_ctx.$t("Osmolarity.Result.Relative")), 1),
            _hoisted_31,
            _hoisted_32
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.compounds, (compound, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, _toDisplayString(compound.name), 1),
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.round((_ctx.results.totalSolutionVolume / 1000) * compound.osmolarity)), 1),
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.round(compound.osmolarity)), 1)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("Osmolarity.Result.AbsolutelyDescription")), 1),
          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("Osmolarity.Result.RelativeDescription")), 1),
          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("Osmolarity.Result.AdditionalInfo")), 1)
        ])
      ])
    ], 4)
  ]))
}